import { render, staticRenderFns } from "./IgnoredOrders.vue?vue&type=template&id=2ee9152c"
import script from "./IgnoredOrders.vue?vue&type=script&lang=js"
export * from "./IgnoredOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports